"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = normalizeDate;

function normalizeDate(date) {
  return date || new Date();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Calendar/helpers/normalizeDate.js
// module id = +xnb
// module chunks = 0